import { Component, OnInit } from '@angular/core';
import { OrganisationService } from "./organisation.service";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-create-organisation',
  templateUrl: './create-organisation.component.html',
  styleUrls: ['./create-organisation.component.css']
})
export class CreateOrganisationComponent implements OnInit {

  title = 'Create Workspace | Digital Assets Management | Workspace';

  currentUser: User;
  currentValue: string
  workspacename: string = '';
  mobileView: boolean = false;
  loginStyle = "none";
  workspace_token: string;
  isShowCreateWorkspaceError: boolean = false
  createWorkspaceErrorMessage: string;
  isShowCreateLoginWorkspaceError: boolean = false
  createWorkspaceLoginErrorMessage: string;
  screenId: any;
  backWorkspaceName: string;
  showLeaveLoader: boolean = false;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  public lat;
  public lng;

  constructor(
    private organisationService: OrganisationService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private titleService: Title,
    private metaTagService: Meta,
    private authService: AuthService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'Create a workspace with a uniue name and get access to the workspace to create boards and upload your work like images, illustrations, etc.'},
      { name: 'keywords', content: 'create workspace, workspace, dam, DAM, digital assets management, assets, digital' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.authService.authState.subscribe((user) => {
      if (user && !this.authenticationService.currentUserValue) {
        this.loginToServer(user, user.photoUrl, this.workspace_token);
      }
    });

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) {
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    this.getWorkspaceDataDetails();

    if (this.currentUser) {
      this.backWorkspaceName = "Back to Workspace";
      this.currentValue = "Logout";
    }else{
      this.backWorkspaceName = "Back to Login";
      this.currentValue = "Login";
      this.router.navigate(['/login']);
    }

    this.getLocation();
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }

  getWorkspaceDataDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceCreationScreenDetails'));
    this.screenId = details.screenId;
  }

  createWorkspace(workspaceName: any){
    if (this.currentUser) {
      if(this.creatwWorkspace.valid) {
        this.showLeaveLoader = true;
        this.isShowCreateWorkspaceError = false
        this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
          this.showLeaveLoader = false;
          this.creatwWorkspace.reset();
          localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data.id,
            workspaceName: data.title, userRole: data.role }));
          this.router.navigate(['/dam']);
        },
        (error) => {
          if(error.status == 403){
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true
            this.createWorkspaceErrorMessage = error.error.Message;
          } else {
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true
            this.createWorkspaceErrorMessage = error.error.Message;
          }
       });
      }
    }else{
      this.isShowCreateLoginWorkspaceError = true
      this.createWorkspaceLoginErrorMessage = "Login to Continue";
    }
  }

  backToWorkspace() {
    if (this.currentUser) {
      this.router.navigate(['/dam']);
    }else{
      this.router.navigate(['/login']);
    }
  }

  openLoginClass() {
    if (this.currentUser) {

    }else{
      this.router.navigate(['/login']);
    }
  }

  loginLogout(){
    if (this.currentUser) {
      this.authenticationService.logout();
      this.authService.signOut();
      this.currentValue = "Login";
    }else{
      this.router.navigate(['/login']);
      this.currentValue = "Logout";
    }
  }

    openLoginDialog(){
      this.loginStyle = "block";
    }

    closeLoginDialog(){
      this.loginStyle = "none";
    }

    signInWithGoogle(): void {
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
    }

    loginToServer(user: any = null, photoUrl: string, workspace_token: string) {
      this.authenticationService.login(user.provider.toLowerCase(), user.id,
      user.authToken, user.email, user.firstName, user.lastName, photoUrl,
      this.lat, this.lng, workspace_token)
        .subscribe(
          (_data) => {
            this.closeLoginDialog();
            this.listWorkspace();
          }
        );
    }

    listWorkspace(){
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data[0].id,
            workspaceName: data[0].title }));
          this.router.navigate(['/dam']);
        }else{
          this.router.navigate(['/create-workspace']);
        }
      });
    }

    goToMarketplace() {
      window.open("https://crafttor.com/marketplace", "_blank");
    }
}
